import {
  Mention,
  mentionTrailingSpace,
  type MentionItem,
  type MentionSource,
} from '@/features/mention';
import { renderPersonIcon } from '@/features/people-wiki/mentions/people-mention-source';

import {
  teamChatMembersOf,
  type TeamChatMember,
} from './team-chat-members.store';

import type { Editor } from '@tiptap/core';

export const TEAM_MEMBER_KIND = 'team-member';

/** The project's members, first in the picker of a team chat composer and absent from every other */
export const createTeamChatMemberSource = (): MentionSource => ({
  kind: TEAM_MEMBER_KIND,
  title: 'In this project',
  listItems: (editor) =>
    Promise.resolve(
      teamChatMembersOf(editor.storage.composerDraftContext?.getDraftId()).map(
        memberToMention
      )
    ),
  renderIcon: renderPersonIcon,
});

const memberToMention = (member: TeamChatMember): MentionItem => ({
  id: String(member.userId),
  kind: TEAM_MEMBER_KIND,
  name: member.name,
  subtitle: `${member.isOwner ? 'Owner' : 'Member'} · gets a notification and a draft`,
  isSubtitleSearchable: false,
});

export const insertMemberMention = (editor: Editor, member: TeamChatMember) =>
  editor
    .chain()
    .focus('end')
    .insertContent([
      { type: Mention.name, attrs: memberToMention(member) },
      mentionTrailingSpace,
    ])
    .run();

export const mentionedMemberIds = (
  mentions: readonly MentionItem[]
): number[] =>
  mentions.flatMap(({ kind, id }) =>
    kind === TEAM_MEMBER_KIND ? [Number(id)] : []
  );
